import { usePrevious } from '@as/cotopaxi';
import { AddressFieldName } from '@as-react/common-types';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { DELAY } from '../../../../constants/GeneralConstants';
import { mapWithAssert } from '../../../../util/ArrayUtil';
import { generateFieldName } from '../../../../util/BuyFormUtil';
export const CountryChangeWatcher = ({ countryIdFieldName, fieldPrefix = '', vatNumberFieldName = '', }) => {
    const fields = mapWithAssert([
        AddressFieldName.POSTCODE,
        AddressFieldName.CITY,
        AddressFieldName.FINDER,
        AddressFieldName.HOUSE_NUMBER,
        AddressFieldName.HOUSE_NUMBER_ADDITION,
        AddressFieldName.ADDRESS,
        AddressFieldName.ADDRESS_LINE_2,
        AddressFieldName.ADDRESS_LINE_3,
        AddressFieldName.ADDRESS_LINE_4,
        AddressFieldName.COUNTY,
        AddressFieldName.CUSTOM_TOWN,
        AddressFieldName.STATE,
    ], name => generateFieldName(name, fieldPrefix));
    const { resetField, trigger } = useFormContext();
    const [countryId, vatNumber] = useWatch({ name: [countryIdFieldName, vatNumberFieldName] });
    const countryIdOld = usePrevious(countryId);
    const resetFieldValue = (field) => resetField(field, { keepTouched: false, defaultValue: '' });
    useEffect(() => {
        if (!countryIdOld || String(countryId) === String(countryIdOld))
            return;
        fields.forEach(resetFieldValue);
        setTimeout(() => {
            vatNumberFieldName && vatNumber && trigger(vatNumberFieldName);
        }, DELAY.DELAY_0);
    }, [countryId]);
    return null;
};
